import BasicLayout from '@/layouts/basic-layout';

const meta = {
    auth: true
};

const pre = 'bcos-audit';

export default {
    path: '/bcos/audit',
    name: '交易审计',
    redirect: {
        name: `${pre}transactionCharts`
    },
    meta,
    component: BasicLayout,
    children: [
        {
            path: 'transactionCharts',
            name: `${pre}transactionCharts`,
            meta: {
                ...meta,
                title: '用户交易',
                closable: true
            },
            component: () => import('@/bcos/views/audit/transaction-charts.vue')
        },
        {
            path: 'unusualUser',
            name: `${pre}unusualUser`,
            meta: {
                ...meta,
                title: '异常用户',
                closable: true
            },
            component: () => import('@/bcos/views/audit/unusual-user.vue')
        },
        {
            path: 'unusualContract',
            name: `${pre}unusualContract`,
            meta: {
                ...meta,
                title: '异常合约',
                closable: true
            },
            component: () => import('@/bcos/views/audit/unusual-contract.vue')
        },
    ]
};
